export const DocgenLocalEnv = {
	DOCGEN_BASE_URL: 'http://localhost:8536',
	CLIENT_ID: 'EroVbL7cQ4bBCZIqtuP8AChiy3HIUXMf',
};
